import React from 'react'

const FullContainerSpinner: React.FC = () => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ height: '100%', minHeight: '100vh' }}>
            <div
                className='spinner-border'
                role='status'
                style={{ width: '6rem', height: '6rem', borderWidth: '0.4rem' }}
            >
                <span className='visually-hidden'>Loading...</span>
            </div>
        </div>
    )
}

export default FullContainerSpinner